/**
 * The situation a form-template assignment resolves a form for. A closed enum
 * (persisted as a Postgres enum) so selecting the form for a given situation in
 * the app is type-safe; adding a new use case is a deliberate migration. Named
 * `useCase` (not `flow`) to avoid confusion with `ReferralWorkflow`.
 */
export enum FormUseCase {
  Triage = 'triage',
  TeleAssessment = 'tele-assessment',
  SimpleEconsult = 'simple-econsult',
  ResponseReview = 'response-review',
}

/**
 * Async processing state of an uploaded form-submission document
 * (OCR → plaintext, AI → summary).
 */
export enum DocumentProcessingStatus {
  Pending = 'pending',
  Processed = 'processed',
  Failed = 'failed',
}
